import React from 'react';

export const STATUS_CHEVRON = {
  completed: { bg: '#52c41a', color: '#fff' },
  active:    { bg: '#0a0a0a', color: '#fff' },
  submitted: { bg: '#fa8c16', color: '#fff' },
  locked:    { bg: '#e8e8e8', color: '#bbb' },
  skipped:   { bg: '#f0f0f0', color: '#ccc' },
};

const CHEVRON_H = 40;
const CHEVRON_NOTCH = 14;
const CHEVRON_W = 150;

export default function StagePipeline({ stages, selected, onSelect, clickable = false, previewMode = false }) {
  return (
    <div style={{ overflowX: 'auto', paddingBottom: 4 }}>
      <div style={{ display: 'flex', alignItems: 'stretch', width: 'max-content' }}>
        {stages.map((stage, i) => {
          const cs = STATUS_CHEVRON[stage.stage_status] || STATUS_CHEVRON.locked;
          const isSelected = selected?.progress_id === stage.progress_id;
          const isPreviewLocked = previewMode && i > 0;
          const interactive = !isPreviewLocked && (clickable || ['active', 'submitted', 'completed'].includes(stage.stage_status));
          return (
            <div
              key={stage.progress_id ?? stage.stage_id}
              onClick={interactive ? () => onSelect(stage) : null}
              title={stage.stage_name}
              style={{
                height: CHEVRON_H,
                width: CHEVRON_W,
                flexShrink: 0,
                display: 'flex', alignItems: 'center',
                paddingLeft: i === 0 ? 12 : CHEVRON_NOTCH + 6,
                paddingRight: CHEVRON_NOTCH + 6,
                gap: 5,
                marginLeft: i === 0 ? 0 : -CHEVRON_NOTCH + 2,
                clipPath: i === 0
                  ? `polygon(0 0, calc(100% - ${CHEVRON_NOTCH}px) 0, 100% 50%, calc(100% - ${CHEVRON_NOTCH}px) 100%, 0 100%)`
                  : `polygon(0 0, calc(100% - ${CHEVRON_NOTCH}px) 0, 100% 50%, calc(100% - ${CHEVRON_NOTCH}px) 100%, 0 100%, ${CHEVRON_NOTCH}px 50%)`,
                background: isPreviewLocked ? '#bbb' : (isSelected ? (stage.stage_status === 'locked' || stage.stage_status === 'skipped' ? '#555' : cs.bg) : cs.bg),
                opacity: isPreviewLocked ? 0.65 : stage.stage_status === 'skipped' ? 0.55 : 1,
                filter: isSelected ? 'brightness(0.85)' : 'none',
                cursor: interactive ? 'pointer' : 'default',
                transition: 'filter 0.15s',
                zIndex: isSelected ? 2 : 1,
              }}
            >
              <span style={{ fontSize: 10, fontWeight: 800, color: isPreviewLocked ? '#555' : cs.color, opacity: 0.7, flexShrink: 0 }}>
                {stage.stage_status === 'completed' ? '✓' : stage.stage_status === 'skipped' ? '—' : i + 1}
              </span>
              <span style={{
                fontSize: 11, fontWeight: 600, color: isPreviewLocked ? '#555' : cs.color,
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
              }}>
                {stage.stage_name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
